import d3 = require("d3");
import * as React from "react";
import {EventDetector} from "../components/EventDetector";
import {applyIfExists} from "./common";

interface Props {
    onHover?: (data: any, event: MouseEvent) => (void | (() => void));
    onHoverEnabled?: boolean; // if undefined act like true
    onHoverColor?: string;
    onBrush?: (...d: any[]) => void;
    onBrushEnabled?: boolean; // if undefined act like true
    withSize?: any;
}

export class HistogramEventsHandler extends React.Component<Props> {

    private divRef: React.RefObject<any>;

    constructor(props) {
        super(props);
        this.divRef = React.createRef();
    }

    public componentDidMount() {
        if (this.props.onBrushEnabled !== false) {
            this.addBrush();
        }
    }

    public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any) {
        if (prevProps.onBrushEnabled !== this.props.onBrushEnabled) {
            if (this.props.onBrushEnabled) {
                this.addBrush();
            } else {
                this.removeBrush();
            }
        }
        if (prevProps.withSize !== this.props.withSize) {
            if (this.props.onBrushEnabled) {
                this.removeBrush();
                this.addBrush();
            }
        }
    }

    public render() {
        return (
            <>
                <EventDetector
                    on={{
                        mouseover: (e) => {
                            if (!e.target || this.props.onHoverEnabled === false) {
                                return;
                            }
                            if (e.target.nodeName === "rect" && e.target.classList.contains("bar")) {
                                const onHoverEnd = applyIfExists(this.props.onHover, e.target.__data__, e);
                                if (this.props.onHoverColor) {
                                    e.target.addEventListener("mouseout", () => {
                                        if (typeof onHoverEnd === "function") {
                                            onHoverEnd();
                                        }
                                        applyIfExists(this.props.onHover, undefined, e);
                                    }, {once: true});
                                }
                            } else {
                                applyIfExists(this.props.onHover, undefined, e);
                            }
                        },
                    }}
                    childRef={this.divRef}
                >
                    {this.props.children}
                </EventDetector>
            </>
        );
    }

    private addBrush = () => {
        const element = this.divRef.current;
        const svgDOM = element.querySelector("svg");

        const scale = (x) => x / svgDOM.clientWidth;

        const brush = d3.brushX()
            .extent([[0, 0], [svgDOM.clientWidth, svgDOM.clientHeight]])
            .on("end", ({selection}) => {
                if (this.props.onBrush && this.props.onBrushEnabled !== false && selection) {
                    this.props.onBrush(selection.map(scale));
                    brushArea.call(brush.move, null);
                }
            });

        const brushArea = d3.select(svgDOM)
            .selectAll(".chart-bg")
            .append("g")
            .attr("class", "brush")
            .call(brush)
            .call(brush.move, null);
    }

    private removeBrush = () => {
        const element = this.divRef.current;
        const svgDOM = element.querySelector("svg");

        d3.select(svgDOM)
            .selectAll(".brush")
            .remove();
    }
}
